<div class="consent" *ngIf="showConsent">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <h4 class="pt-4">{{'consent_main_title' | translate}}</h4>
            </div>

            <div class="col-md-6 text-right">
                <button class="button sm-100 mr-2" (click)="confirmAll()">
                {{"consent_confirm_all" | translate}}
            </button>
                <button class="button sm-100 mr-2" (click)="confirmFunc()">
                {{"consent_functional_only" | translate}}
            </button>
                <button class="button sm-100" (click)="dialogService.openConsentDialog(); showConsent = false">
                {{"consent_more_info" | translate}}
            </button>
            </div>
        </div>
    </div>
</div>